export default __webpack_public_path__ + "locales/pt/Ldap.json?hash=5738471f81ae3e999b05604491317fef";